import { fetchRequest } from "../../request/request";
import { ChangePasswordInterface } from "./change-password.component";

export const changePassword = async (
  values: ChangePasswordInterface
): Promise<void> => {
  return fetchRequest("/user/change-password/", values, "post");
};
